import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProductsHeader from "../../../NewProductList/components/ProductsHeader/ProductsHeader";
import { Button, Chip, CircularProgress } from "@mui/material";

export default function ViewPartnerEmailConfig(props) {
  if (props.isLoading) {
    return <div style={{ textAlign: 'center' }}>
      <CircularProgress />
    </div>
  }

  const [expandedPartnerEmailConfigs, setExpandedPartnerEmailConfigs] = React.useState(false)

  const partnerEmailConfiguration = props.partnerConfigEmail

  // Utility to mask sensitive values
  const maskValue = (key, value) => {
    const sensitiveKeys = ["password", "username", "user", "pass", "secret", "token"];
    if (sensitiveKeys.some(sensitiveKey => key.toLowerCase().includes(sensitiveKey))) {
      return "*************";
    }
    return value;
  };

  const openEmailTemplatesPage = () => {
    window.location.hash = '/admin/view_email_templates';
  };

  return (
    <div style={{ marginTop: "3%" }}>
      <>
        {/* Partner Email Configurations*/}
        <Accordion expanded={expandedPartnerEmailConfigs}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon onClick={() => { setExpandedPartnerEmailConfigs(!expandedPartnerEmailConfigs) }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <ProductsHeader
              title={"Partner Email Configurations (Legacy)"}
              showEditButton={true}
              onEditButtonClick={props.openUpdatePartnerConfigEmailDialog}
            />
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ marginBottom: "12px", textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={openEmailTemplatesPage}
              >
                Manage in Email Templates
              </Button>
            </div>
            <TableContainer component={Paper} style={{ marginTop: "2%" }}>
              <Table sx={{ minWidth: 650 }} aria-label="email config table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table-cell-header">Property</TableCell>
                    <TableCell className="table-cell-header">Value</TableCell>
                  </TableRow>
                </TableHead>
                {partnerEmailConfiguration && Object.keys(partnerEmailConfiguration).length > 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell><strong>Client Type</strong></TableCell>
                      <TableCell>{partnerEmailConfiguration.client_type}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Is Active</strong></TableCell>
                      <TableCell>
                        <Chip
                          label={partnerEmailConfiguration.is_active ? "Active" : "Inactive"}
                          color={partnerEmailConfiguration.is_active ? "success" : "default"}
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Description</strong></TableCell>
                      <TableCell>{partnerEmailConfiguration.description}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Config</strong></TableCell>
                      <TableCell>
                        {Object.entries(partnerEmailConfiguration.config || {}).map(([key, value]) => (
                          <div key={key}>
                            <strong>{key}:</strong> {maskValue(key, value)}
                          </div>
                        ))}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Created At</strong></TableCell>
                      <TableCell>{new Date(partnerEmailConfiguration.created_at).toLocaleString()}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><strong>Updated At</strong></TableCell>
                      <TableCell>{new Date(partnerEmailConfiguration.updated_at).toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        No configuration data available.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </AccordionDetails>

        </Accordion>
        <br />
        <br />
      </>

    </div>
  );
}
